import { CheckoutState } from '@shared/types';
import { UseCourseOccurrencesOptions, useOccurrences } from '../useOccurrences';
import { useMemo } from 'react';
import { useCheckoutContext } from '../../CheckoutContext';
import { PublicOccurrence } from '@cademy-package/sdk-component-types';

export type UseOccurrenceProps = {
    checkoutState: CheckoutState;
    courseId: string;
    educatorId: string;
    options?: UseCourseOccurrencesOptions;
};

export const useOccurrence = ({ courseId, educatorId, options }: UseOccurrenceProps) => {
    const { checkoutState } = useCheckoutContext();
    const { data: occurrences } = useOccurrences(courseId, educatorId, options);

    const occurrence = useMemo<PublicOccurrence | null>(() => {
        if (!occurrences) {
            return null;
        }

        if (
            !('date' in checkoutState.stepState) ||
            checkoutState.stepState.date.status !== 'complete'
        ) {
            return null;
        }

        const selectedOccurrenceId = checkoutState.stepState.date.state.selectedDate;

        return (
            occurrences.find((occurrence) => {
                return occurrence._id === selectedOccurrenceId;
            }) || null
        );
    }, [checkoutState, occurrences]);

    if (!occurrence) {
        return null;
    }

    return occurrence;
};
